<mat-form-field class="mt-20 col-xs-12 field-filtre" [hidden]="!filter">
  <mat-label>Filtrer</mat-label>
  <input matInput (keyup)="applyFilter($event)" #input />
  @if (filterValue) {
    <button matSuffix mat-icon-button type="button" aria-label="Effacer le filtre" (click)="clearFilter(input)">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
<div style="overflow-x: auto; z-index: -1">
  <table mat-table [dataSource]="dataSource" matSort #empTbSort="matSort" multiTemplateDataRows aria-describedby="tableDescription">
    @for (column of displayedColumns; track column) {
      <ng-container class="td-wrap" matColumnDef="{{ column }}" [stickyEnd]="column == 'Actions' ? true : false">
        @if (column !== ' ') {
          <div>
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [disabled]="column === 'Sélectionner' || column === 'Statut' || column === 'Actions'"
              [ngClass]="{ 'desactiver-tri-colonne': column === 'Sélectionner' || column === 'Statut' || column === 'Actions' }"
              [ngStyle]="this.headerStyleCss.hasOwnProperty(column) ? this.headerStyleCss[column] : {}"
            >
              @if (column == 'Sélectionner') {
                <section class="example-section">
                  <mat-checkbox
                    color="primary"
                    class="example-margin"
                    (click)="$event.stopPropagation()"
                    (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected('s1') && allselectedActif"
                    [indeterminate]="selection.hasValue() && !isAllSelected('s1') && allselectedActif"
                    [aria-label]="checkboxLabel('s1')"
                    (change)="updateCheckAll()"
                  >
                  </mat-checkbox>
                </section>
              }
              {{ column }}
              <!-- <mat-icon
                style="color: #b7b7b7"
                *ngIf="column !== 'Sélectionner' && column !== 'Actions'"
                class="icon-filter"
                (click)="toggleFilter(column)"
                >
                filter_alt
              </mat-icon> -->
              <!-- Filter Input -->
              @if (filterVisible[column] && column !== 'Sélectionner' && column !== 'Actions') {
                <mat-form-field>
                  <input matInput placeholder="Filter by {{ column }}" />
                </mat-form-field>
              }
            </th>
          </div>
        }
        @if (column == ' ') {
          <th mat-header-cell *matHeaderCellDef>
            <section class="example-section pointer">
              @if (!showAllSubTable) {
                <mat-icon matTooltip="Déplier tous les volets détails" (click)="toggleSubTable()"
                  ><span class="material-symbols-outlined"> expand_all </span></mat-icon
                >
              }
              @if (showAllSubTable) {
                <mat-icon matTooltip="Replier tous les volets détails" (click)="toggleSubTable()"
                  ><span class="material-symbols-outlined"> unfold_less </span></mat-icon
                >
              }
            </section>
          </th>
        }
        <td
          class="td-wrap"
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'table-helper': column == 'Actions' }"
          [ngStyle]="this.cellStyleCss.hasOwnProperty(column) ? this.cellStyleCss[column] : {}"
        >
          @if (column == 'Sélectionner') {
            <span class="text-left">
              <span>
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element) : null"
                  [checked]="selection.isSelected(element)"
                  [aria-label]="checkboxLabel(element, 's1')"
                  (change)="updateCheck($event, element)"
                >
                </mat-checkbox>
              </span>
            </span>
          }
          <span>
            @if (isObjectType(element[column])) {
              <span>
                <div class="{{ element[column].class }}">
                  {{ element[column].text }}
                </div>
              </span>
            }
            @if (!isObjectType(element[column])) {
              <span>{{ element[column] }}</span>
            }
          </span>
          @if (column == 'Actions') {
            <span class="text-center">
              @for (action of element.actionOrder || ['validate', 'refuse', 'add', 'edit', 'delete', 'view']; track action) {
                @if (action === 'validate') {
                  <button
                    class="bt-action text-success"
                    matTooltip="valider"
                    mat-button
                    [hidden]="!validable || !element['valider_hidden'] || verifSubtableDisabled(element['subTable'])"
                    (click)="validateSingleItem(element)"
                    aria-label="icon button"
                  >
                    <mat-icon>done</mat-icon>
                  </button>
                }
                @if (action === 'refuse') {
                  <button
                    class="bt-action text-danger"
                    matTooltip="refuser"
                    mat-button
                    [hidden]="!refusable || element['refuser_hidden']"
                    (click)="refuseSingleItem(element)"
                    aria-label="icon button"
                  >
                    <mat-icon>clear</mat-icon>
                  </button>
                }
                @if (action === 'add') {
                  <button
                    class="bt-action"
                    [hidden]="!addable || element['add_hidden'] || element['addUserInactif']"
                    matTooltip="Ajouter une délégation"
                    mat-button
                    (click)="addDelegtaion(element)"
                  >
                    <mat-icon class="icon-zoom pointer">add</mat-icon>
                  </button>
                }
                @if (action === 'delete') {
                  <button class="bt-action" [hidden]="!delatable" matTooltip="Supprimer" mat-button (click)="delete(element['id'])">
                    <mat-icon class="icon-zoom pointer">delete</mat-icon>
                  </button>
                }
                @if (action === 'edit') {
                  <button class="bt-action" [hidden]="!editable" matTooltip="Modifier" mat-button (click)="edit(element['id'])">
                    <mat-icon class="icon-edit pointer">edit</mat-icon>
                  </button>
                }
                @if (action === 'view') {
                  <button
                    class="bt-action"
                    [hidden]="!hasView"
                    [matTooltip]="zoomTooltip"
                    mat-button
                    (click)="showTableDetail(element['id'])"
                  >
                    <mat-icon class="icon-zoom pointer">zoom_in</mat-icon>
                  </button>
                }
              }
            </span>
          }
        </td>
      </ng-container>
    }
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element"></td>
      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="displayedColumns.length"
          [ngStyle]="{ border: !element.isExpanded ? '0px' : '' }"
        >
          <div
            class="example-element-detail"
            [@detailExpand]="element.isExpanded ? 'expanded' : 'collapsed'"
            [class.example-expanded-div]="element.isExpanded"
          >
            <table class="sub-table-border" aria-describedby="tableDescription">
              <tr>
                @for (keyValue of subTableData[0] | keyvalue: originalOrder; track keyValue) {
                  <th scope="col">
                    @if (keyValue.key == 'Sélectionner') {
                      <section class="example-section">
                        <mat-checkbox class="example-margin" [checked]="subTableAllSelected" (change)="selectAllSubTable()"></mat-checkbox>
                      </section>
                    }
                    @if (keyValue.key !== 'checked' && subTableDisplayedColumns.includes(keyValue.key)) {
                      <span>
                        {{ keyValue.key }}
                      </span>
                    }
                  </th>
                }
              </tr>

              <tr>
                @for (keyValue of subTableDisplayedColumns; track keyValue) {
                  <th
                    scope="col"
                    class="col-sub-table"
                    [ngStyle]="this.headerStyleCssSub.hasOwnProperty(keyValue) ? this.headerStyleCssSub[keyValue] : {}"
                  >
                    @if (keyValue != 'Actions' && subTableDisplayedColumns.includes(keyValue)) {
                      {{ keyValue }}
                    }
                  </th>
                }
              </tr>

              @for (item of element['subTable']; track item) {
                <tr>
                  @for (keyValue of item | keyvalue: originalOrder; track keyValue) {
                    @if (keyValue.key !== 'id') {
                      @if (
                        (keyValue.key !== 'checked' &&
                          keyValue.key !== 'valider_hidden' &&
                          subTableDisplayedColumns.includes(keyValue.key)) ||
                        keyValue.key == 'action'
                      ) {
                        <td
                          [ngStyle]="this.cellStyleCssSub.hasOwnProperty(keyValue.key) ? this.cellStyleCssSub[keyValue.key] : {}"
                          class="col-sub-table-td"
                        >
                          @if (keyValue.key == 'Sélectionner') {
                            <span>
                              @if (keyValue.key == 'Sélectionner') {
                                <section class="example-section">
                                  <mat-checkbox [checked]="selection.isSelected(element)" (change)="updateCheck($event, item, element)">
                                  </mat-checkbox>
                                </section>
                              }
                            </span>
                          }
                          @if (
                            keyValue.key !== 'checked' &&
                            keyValue.key !== 'Sélectionner' &&
                            keyValue.key !== 'valider_hidden' &&
                            keyValue.key !== 'delete_disabled' &&
                            keyValue.value &&
                            !keyValue.value.object &&
                            subTableDisplayedColumns.includes(keyValue.key)
                          ) {
                            <span>
                              {{ keyValue.value }}
                            </span>
                          }
                          @if (
                            keyValue.key !== 'checked' &&
                            keyValue.key !== 'Sélectionner' &&
                            keyValue.key !== 'valider_hidden' &&
                            keyValue.key !== 'delete_disabled' &&
                            keyValue.value &&
                            keyValue.value.object
                          ) {
                            <span>
                              <div class="{{ keyValue.value.class }}" style="text-align: center">
                                {{ keyValue.value.text }}
                              </div>
                            </span>
                          }
                          @if (keyValue.key == 'action') {
                            <span class="example-section">
                              <button
                                class="bt-action"
                                (click)="showTableDetailSub(item['id'])"
                                [hidden]="!zoom"
                                matTooltip="Voir le détail"
                                mat-icon-button
                                color="primary"
                              >
                                <mat-icon>zoom_in</mat-icon>
                              </button>
                              <button
                                class="bt-action text-success"
                                matTooltip="valider"
                                mat-icon-button
                                [hidden]="!validable || item['valider_hidden']"
                                (click)="validateSingleItem(item)"
                                aria-label="Example icon button with a vertical three dot icon"
                              >
                                <mat-icon>done</mat-icon>
                              </button>
                              <button
                                class="bt-action text-danger"
                                matTooltip="refuser"
                                mat-icon-button
                                [hidden]="!refusable || item['valider_hidden']"
                                (click)="refuseSingleItem(item)"
                                aria-label="Example icon button with a vertical three dot icon"
                              >
                                <mat-icon>clear</mat-icon>
                              </button>
                            </span>
                          }
                        </td>
                      }
                    }
                  }
                </tr>
              }
            </table>
          </div>
        </td>
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr
      mat-row
      *matRowDef="let row; let index = dataIndex; columns: displayedColumns"
      class="example-element-row"
      [ngClass]="{ 'row-altern': index % 2 != 0 }"
      [class.example-expanded-row]="row.isExpanded"
      actions
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [hidden]="!row.isExpanded"></tr>
  </table>
</div>
@if (hasPagination) {
  <mat-paginator
    [pageSizeOptions]="[10, 15, 20, 25, 30, 40, 50, 75, 100]"
    [pageSize]="limit"
    [pageIndex]="offset"
    (page)="onPageChange($event)"
    [length]="length"
    showFirstLastButtons
  ></mat-paginator>
}
